import {Button, ButtonProps} from "@progress/kendo-react-buttons";
import {VivoPortal} from "@utils/AppConstants";
import EnumIconButtonDefaultType = VivoPortal.EnumIconButtonDefaultType;
import './FlintIconButton.scss'
import FlintIcon from "@components/controls/buttons/FlintIcon";

export default function FlintIconButton(props: FlintIconButtonProps) {
    const {themeColor = "secondary", type = "button", className, iconEnum, disabled, ...others} = props;
    const c = props.className ? `icon-btn ${props.className}` : "icon-btn";
 
    return (
        <Button className={c} themeColor={disabled == true ? "secondary" : themeColor} type= {type} disabled={disabled} {...others}>
            <FlintIcon iconEnum={iconEnum}/>
        </Button>
    )
}

export interface FlintIconButtonProps extends ButtonProps {
    iconEnum?: EnumIconButtonDefaultType;
}